<div @fadeInAnimation>
  <div class="order-page-title" id="top">
    <eps-button (buttonClick)="cancelClicked()" *ngIf="panelStatus.backButton.isVisible" label="SHARED.BUTTONS.BACK"></eps-button>
    <div *ngIf="mode.state === 'view'" class="content">
      <div class="title">
        <app-status *ngIf="mode.state === 'view'" layout="BULLET" key="{{ 'FLOW_' + flowDetail.status }}" height="40" [size]="1"></app-status>
        <div class="multi-line">
          <div>
            <app-title title="FLOWS.DETAILS.TITLE"></app-title>
            <span class="subtitle">{{ flowDetail.etmOrderNumber }}</span>
          </div>
          <div *ngIf="flowDetail.registeredBy">
            <span class="bold">{{ 'ORDERS.DETAILS.REGISTERED_BY' | translate }}</span>
            {{ flowDetail.registeredBy }}
          </div>
        </div>
      </div>
      <div class="action_buttons">
        <div class="show-from-md">
          <eps-button (buttonClick)="editFlow()" *ngIf="canEdit()" label="FLOWS.LIST.BUTTONS.EDIT_FLOW_REGISTRAR"></eps-button>
          <eps-button (buttonClick)="handshakeFlow()" *ngIf="canHandshake()" label="FLOWS.LIST.BUTTONS.EDIT_FLOW_HANDSHAKER"></eps-button>
        </div>
        <!-- START Mobile version -->
        <div class="more_ellipsis hide-from-sm" [matMenuTriggerFor]="menuOrderLine" *ngIf="canEdit()">
          <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
        </div>
        <mat-menu #menuOrderLine="matMenu" [overlapTrigger]="false">
          <button mat-menu-item type="button" (click)="editFlow()" *ngIf="canEdit()">
            <span>&nbsp;{{ 'FLOWS.LIST.BUTTONS.EDIT_FLOW_REGISTRAR' | translate }}&nbsp;</span>
          </button>
          <button mat-menu-item type="button" (click)="handshakeFlow()" *ngIf="canHandshake()">
            <span>&nbsp;{{ 'FLOWS.LIST.BUTTONS.EDIT_FLOW_HANDSHAKER' | translate }}&nbsp;</span>
          </button>
        </mat-menu>
        <!-- END Mobile version -->
      </div>
    </div>
    <app-title *ngIf="isCreateFlow" title="SHARED.BUTTONS.CREATE" subtitle="FLOWS.DETAILS.TITLE"></app-title>
    <app-title *ngIf="isEditFlow" title="SHARED.BUTTONS.EDIT" subtitle="FLOWS.DETAILS.TITLE"></app-title>
    <app-title *ngIf="isHandshakeFlow" title="FLOWS.LIST.BUTTONS.ACCEPT" subtitle="FLOWS.DETAILS.TITLE"></app-title>
    <app-title *ngIf="isEditDispute" title="FLOWS.LIST.BUTTONS.EDIT_DISPUTE" subtitle="FLOWS.DETAILS.TITLE"></app-title>
  </div>

  <div class="row filter-container">
    <div class="col-12 col-md-12 col-lg-9 filter-container-inner">
      <!-- CUSTOMER -->
      <div class="order-create-title-bar" *ngIf="panelStatus.customer.blockIsVisible">
        <div class="title-action-bar order-create-title-bar-header" [ngClass]="{ activated: panelStatus.customer.isEdit }">
          <div class="order-create-title">
            <i class="fa fa-address-card" aria-hidden="true"></i>
            <b>{{ panelStatus.customer.nr }}&nbsp;&nbsp;{{ 'ORDERS.CUSTOMER.TITLE' | translate }}</b> {{ 'ORDERS.DELIVERY.SUBTITLE' | translate }}
          </div>
          <div
            class="edit-button"
            *ngIf="(panelStatus.customer.isEditable || mode.editWindow === 'delivery' || mode.editWindow === 'detail' || mode.editWindow === 'planning') && !panelStatus.busy"
          >
            <eps-button (click)="resetCreatePage()" label="SHARED.BUTTONS.RESET"></eps-button>
          </div>
        </div>
      </div>
      <app-florder-select-customer
        [panelStatus]="panelStatus.customer"
        [customer]="flowDetail.customer"
        [customers]="customers"
        [showCancel]="isCreate()"
        (nextClicked)="setCustomer($event)"
        (cancelClicked)="cancelClicked()"
        *ngIf="panelStatus.customer.blockIsVisible"
      ></app-florder-select-customer>

      <!-- DELIVERY -->
      <div class="order-create-title-bar" *ngIf="panelStatus.delivery.blockIsVisible">
        <div class="order-create-title-bar-header title-action-bar" [ngClass]="{ activated: panelStatus.delivery.isEdit }">
          <div id="step-delivery" class="order-create-title">
            <i class="fa fa-truck" aria-hidden="true"></i>
            <b>{{ panelStatus.delivery.nr }}&nbsp;&nbsp;{{ 'FLOWS.DELIVERY.TITLE' | translate }}</b> {{ 'FLOWS.DELIVERY.SUBTITLE' | translate }}
          </div>
          <eps-button
            *ngIf="panelStatus.delivery.isEditable"
            (click)="editDeliveryMethodClicked()"
            label="SHARED.BUTTONS.EDIT"
          ></eps-button>
        </div>
        <app-flow-edit-delivery
          *ngIf="panelStatus.delivery.isVisible"
          [busy]="(busy$ | async) || false "
          [definitions]="definitions"
          [deliveryMethod]="flowDetail.deliveryMethod"
          [panelStatus]="panelStatus.delivery"
          [flowDetail]="flowDetail"
          [flowHandshakeTypes]="flowHandshakeTypes"
          [flowRegistrationTypes]="flowRegistrationTypes"
          [filterValues]="filterValues"
          [isCreateFlow]="isCreateFlow"
          (cancelClicked)="cancelClicked()"
          (nextClicked)="setDeliveryMethod($event)"
          (formValidChanged)="formValidChanged('delivery', $event)"
          (resetMaterialsAndPlanning)="resetMaterialsAndPlanning()"
          (flowTypeSelected)="loadContractInfoFromFlowTypeToIncoterm($event)"
          (emptyContract)="showEmptyContractModal()"
        ></app-flow-edit-delivery>
      </div>

      <!-- ORDER DETAILS -->
      <div class="order-create-title-bar" *ngIf="panelStatus.detail.blockIsVisible">
        <div class="title-action-bar order-create-title-bar-header" [ngClass]="{ activated: panelStatus.detail.isEdit }">
          <div id="step-details" class="order-create-title">
            <i class="fa fa-file-o" aria-hidden="true"></i>
            <b>{{ panelStatus.detail.nr }}&nbsp;&nbsp;{{ 'FLOWS.DETAILS.TITLE' | translate }}</b> {{ 'ORDERS.DETAILS.SUBTITLE' | translate }}
          </div>
          <eps-button
            *ngIf="panelStatus.detail.isEditable"
            (click)="editDetailClicked()"
            label="SHARED.BUTTONS.EDIT"
          ></eps-button>
        </div>
      </div>
      <app-flow-edit-detail
        *ngIf="panelStatus.detail.isVisible"
        [definitions]="definitions"
        [editMaterial]="mode.material"
        [flowDetail]="flowDetail"
        [panelStatusMaterial]="panelStatus.material"
        [panelStatus]="panelStatus.detail"
        [lineItemValidation]="lineItemValidation"
        [materialTypes]="incoterm"
        [sort]="sort"
        (cancelClicked)="cancelClicked()"
        (backClicked)="backToDeliveryClicked()"
        (nextClicked)="saveDetails()"
        (saveMaterialClicked)="saveMaterial($event)"
        (removeMaterialClicked)="removeMaterial($event)"
        (startEditMaterialClicked)="editMaterial($event)"
        (formValidChanged)="formValidChanged('detail', $event)"
        (showQuantityModal)="showQuantityModal()"
        [maxAmountPopupIsShown]="maxAmountPopupIsShown"
        (resetMaxAmountPopup)="sandbox.resetMaxAmountPopup()"
        (goBackClicked)="cancel()"
        (sortChange)="sortChanged($event)"
      ></app-flow-edit-detail>

      <!-- PLANNING -->
      <div class="order-create-title-bar" *ngIf="panelStatus.detail.blockIsVisible">
        <div class="title-action-bar order-create-title-bar-header" [ngClass]="{ activated: panelStatus.planning.isEdit }">
          <div id="step-planning" class="order-create-title">
            <i class="fa fa-calendar-check-o" aria-hidden="true"></i>
            <b>{{ panelStatus.planning.nr }}&nbsp;&nbsp;{{ 'FLOWS.PLANNING.TITLE' | translate }}</b> {{ 'FLOWS.PLANNING.SUBTITLE' | translate }}
          </div>
          <eps-button
            *ngIf="panelStatus.planning.isEditable"
            (click)="editPlanningClicked()"
            label="SHARED.BUTTONS.EDIT"
          ></eps-button>
        </div>
      </div>
      <app-flow-edit-planning
        *ngIf="panelStatus.planning.isVisible"
        [flowDetail]="flowDetail"
        [flowDate]="flowDate"
        [panelStatus]="panelStatus.planning"
        [datesRange]="datesRange"
        [frequency]="to?.frequency"
        [triggerValidation]="triggerPlanningValidation"
        (cancelClicked)="cancelClicked()"
        (backClicked)="backToDetailClicked()"
        (nextClicked)="savePlanning($event)"
        (formValidChanged)="formValidChanged('planning', $event)"
      ></app-flow-edit-planning>
    </div>
  </div>

  <div class="col-12 col-md-12 col-lg-9 buttons">
    <eps-button
      *ngIf="showBack$ | async"
      (buttonClick)="panelStatus.submitButton.isEnabled && cancel()"
      label="SHARED.BUTTONS.BACK"
    ></eps-button>
    <eps-button
      type="link"
      *ngIf="showCancel()"
      (buttonClick)="panelStatus.submitButton.isEnabled && cancel()"
      label="SHARED.BUTTONS.CANCEL"
    ></eps-button>
    <eps-button
      [disabled]="!panelStatus.submitButton.isEnabled || mode.saving || !formsAreValid.all"
      [busy]="mode.saving"
      (buttonClick)="panelStatus.submitButton.isEnabled && formsAreValid.all && submitClicked()"
      *ngIf="showSubmit()"
      [submit]="nextOnEnterPressed$ | async"
      label="SHARED.BUTTONS.SUBMIT"
    ></eps-button>
  </div>
</div>
